import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcInfo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 9.82q.375 0 .643.266a.88.88 0 0 1 .266.643v5.808q0 .375-.267.643a.88.88 0 0 1-.644.267.87.87 0 0 1-.643-.267.88.88 0 0 1-.266-.643V10.73q0-.375.268-.643A.88.88 0 0 1 12 9.82M12 8.848q-.474 0-.812-.337a1.1 1.1 0 0 1-.337-.812q0-.474.337-.812.338-.337.812-.337t.811.337.338.812-.338.812a1.1 1.1 0 0 1-.811.337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5",
    clipRule: "evenodd"
  }));
}
var IcInfo = createNolIcon(/*#__PURE__*/forwardRef(SvgIcInfo));

export { IcInfo as I };
